import React from 'react';
export function Footer() {
  return <footer className="w-full bg-white py-8 px-4 border-t border-gray-100" data-id="element-61">
      <div className="max-w-4xl mx-auto flex flex-col items-center space-y-4 text-center" data-id="element-62">
        <div className="flex flex-wrap justify-center gap-3 text-gray-400" data-id="element-63">
          <span className="font-medium border border-gray-200 px-2 py-1 rounded text-xs" data-id="element-64">
            VISA
          </span>
          <span className="font-medium border border-gray-200 px-2 py-1 rounded text-xs" data-id="element-65">
            Mastercard
          </span>
          <span className="font-medium border border-gray-200 px-2 py-1 rounded text-xs" data-id="element-66">
            MercadoPago
          </span>
        </div>

        <div className="text-xs text-text-muted space-y-2" data-id="element-67">
          <p data-id="element-68">
            © {new Date().getFullYear()} Sistema de Sanación Emocional
            Integral. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-4" data-id="element-69">
            <a href="#" className="hover:text-primary transition-colors" data-id="element-70">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-primary transition-colors" data-id="element-71">
              Política de Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}